import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useMilitaryChartsDataContext } from './hooks/useMilitaryChartsDataContext';
import { useMemo } from 'react';

const monthNames = [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Maio',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez'
];

const getMonthLabel = (mes) => {
    const monthIndex = parseInt(mes) - 1;
    const monthName = monthNames[monthIndex] || mes;
    return `${monthName}`;
};

export const CommandEvolutionMonth = () => {
    const { chartData } = useMilitaryChartsDataContext();

    // Transform data to show each command (cmd) evolution by month
    const { series, categories } = useMemo(() => {
        let monthData = chartData?.commandEvolutionMonth || [];
        
        if (!monthData.length) {
            return { series: [], categories: [] };
        }

        // Sort data chronologically by year and month
        monthData = [...monthData].sort((a, b) => {
            const yearDiff = parseInt(a.ano_estatistica) - parseInt(b.ano_estatistica);
            if (yearDiff !== 0) return yearDiff;
            return parseInt(a.mes_estatistica) - parseInt(b.mes_estatistica);
        });

        // Limit to 12 consecutive months (last 12)
        monthData = monthData.slice(-12);

        // Get all unique commands
        const cmdsSet = new Set();
        monthData.forEach(period => {
            period.comandos?.forEach(cmd => {
                cmdsSet.add(cmd.cmd);
            });
        });

        // Create series for each command
        const cmdSeries = Array.from(cmdsSet).map(cmdName => {
            const data = monthData.map(period => {
                const cmdData = period.comandos?.find(c => c.cmd === cmdName);
                return cmdData?.total || 0;
            });
            return {
                name: cmdName,
                data: data
            };
        });

        // Get month/year as categories
        const monthCategories = monthData.map(item => 
            getMonthLabel(item.mes_estatistica)
        );

        return {
            series: cmdSeries,
            categories: monthCategories
        };
    }, [chartData?.commandEvolutionMonth]);

    return (
        <SimpleBars
            title={'Ocorrências por Comando (Mensal)'}
            horizontal={false}
            stacked={true}
            subtitles={categories}
            series={series}
            isMoney={false}
            showDataLabels={false}
        />
    );
};